import { render, staticRenderFns } from "./LeftBarNavGroup.vue?vue&type=template&id=f22e07b0&scoped=true&"
import script from "./LeftBarNavGroup.vue?vue&type=script&lang=ts&"
export * from "./LeftBarNavGroup.vue?vue&type=script&lang=ts&"
import style0 from "./LeftBarNavGroup.vue?vue&type=style&index=0&id=f22e07b0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22e07b0",
  null
  
)

export default component.exports